import type { UserRole } from "@/api/auth";

// 全局目录与市场价共用服务端factor_catalogs.write，复用已有角色事实。
export { canReviewMarketPrices as canEditGlobalCatalog } from "@/pages/admin/marketPriceReviewRoles";

/** 本厂定价与设置入口，必须与后端三个定价权限集合一致。 */
export const QUOTE_SETTINGS_ROLES: readonly UserRole[] = [
  "it_admin",
  "plant_manager",
  "platform_ops",
  "process_lead",
];

/** 只控制标定写入；IT可以查看和只读试算，不可生效/回滚。 */
export const CALIBRATION_WRITE_ROLES: readonly UserRole[] = [
  "plant_manager",
  "platform_ops",
  "process_lead",
];

/** 既有受限目录/标定与定价入口四角色；rates/policy的登录只读入口不使用此限制。 */
export function canOpenQuoteSettings(
  role: UserRole | null | undefined,
): boolean {
  return role != null && QUOTE_SETTINGS_ROLES.includes(role);
}

export function canWriteCalibration(
  role: UserRole | null | undefined,
): boolean {
  return role != null && CALIBRATION_WRITE_ROLES.includes(role);
}
